import React, { useContext } from 'react'
import './M_TimeLine.css'
import { Timeline } from "primereact/timeline/timeline.cjs.js"
import { useMediaQuery } from '@mui/material'
import { LoadingContext } from '../M_Utils'

export function M_TimeLine({ valueTimeline, color }) {
    const matches = useMediaQuery('(max-width:600px)')

    const ctx = useContext(LoadingContext)

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'

    const containerTimeline = (item) => {
        return (
            <div className='M_TimeLine' >
                <br />
                {item.date === '' ?
                    <>
                        {item.name}
                    </> :
                    <>
                        <b>{item.name}</b>
                        <br />
                        {item.date}
                    </>
                }
            </div>
        )
    }

    const timelineMarker = (item) => {
        return (
            <span className="custom-marker" style={{ color: color ? color : 'var(--color-black)' }} >
                <i className={item.icon}></i>
            </span>
        )
    }

    return (
        <div className='principalDivM_TimeLine'>
            <div className='divM_TimeLine'>
                {matches ?
                    <Timeline
                        // className='M_Timeline'
                        value={valueTimeline}
                        align="right"
                        marker={timelineMarker}
                        content={containerTimeline}
                    />
                    :
                    <Timeline
                        // className='M_Timeline'
                        value={valueTimeline}
                        layout="horizontal"
                        align="bottom"
                        marker={timelineMarker}
                        content={containerTimeline}
                    />
                }
            </div>
        </div>
    )
}
